var render = function render(){var _vm=this,_c=_vm._self._c;return _c('GenerateDialog',{attrs:{"isOpen":_vm.isOpen,"isLoading":_vm.isLoading,"title":"Generate Payroll","onSubmit":_vm.handleSubmit},on:{"close":_vm.close}})
}
var staticRenderFns = []

export { render, staticRenderFns }